// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"9d02120b","312":"a05fab6e","375":"a1e59388","551":"207cf245","800":"bf58061c"}[chunkId] + ".chunk.js";
};